import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {
    Box,
    Button, Grid,
    TextField,
    Typography
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import apiHelper from "../../../util/ApiHelper";
import {toast} from "react-toastify";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";
import UploadImage from "../UploadImage";
import ColorPicker from "./components/ColorPicker";

const useStylesAll = makeStyles((theme) => ({
    root: {
        margin: 0,
        marginBottom: 20,
        minWidth: "100%",
    },
    last: {
        margin: 0,
    },
    input: {
        width: "100%",
        maxWidth: "380px",
        marginTop: 20,
        marginBottom: 20,
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
        },
    },
}));

const defaultFormValues = {
    localizations: {
        en: {
            title: ''
        },
        tc: {
            title: ''
        },
    },
    icon: "",
    color: "#000000",
    status: 1
}

export default function FilmIconForm({disabled, ...props}) {
    const {history, fetchData, seq, setSeq} = props;
    const classes = useStylesAll();
    let {id} = useParams();
    const [data, setData] = useState(defaultFormValues);

    const {
        control,
        handleSubmit,
        getValues,
        setValue,
        reset
    } = useForm({defaultValues: defaultFormValues});

    const getFilmIcon = React.useCallback(async () => {
        if (id) {
            apiHelper.hkiff
                .getFilmIconById(id)
                .then((response) => {
                    console.log(response.data);
                    reset(response.data);
                    setData(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }, [id])

    useEffect(() => {
        getFilmIcon();
    }, [getFilmIcon]);

    const updateIcon = async (data) => {
        try {
            const result = await apiHelper.hkiff.updateFilmIconById(
                id,
                data
            );
            if (result.data.id !== undefined) {
                console.log(result.data);
                toast.dark("Your changes is saved.");
                getFilmIcon();
            }
        } catch (err) {
            console.log(err);
        }
    };

    const createIcon = async (data) => {
        try {
            const result = await apiHelper.hkiff.postFilmIcon(
                {...data, sequence: seq ? seq : 0}
            );
            console.log(result);
            if (result.data.id !== undefined) {
                console.log('res', result);
                toast.dark("Icon created.");
                reset(defaultFormValues);
                fetchData();
                setSeq && setSeq(seq + 1);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onSubmit = (data) => {
        const sendIcon = () => {
            if (id) {
                updateIcon(data);
            } else {
                createIcon(data);
            }
        };
        sendIcon();
    };

    return (
        <>
            <Box fontWeight={900} fontSize={13} mb={2}
                 width="100%">
                <Typography
                    variant="p">{props.description}</Typography>
            </Box>
            <form autoComplete="off"
                  onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box width="100%">
                        <Controller
                            control={control}
                            name="localizations.en.title"
                            defaultValue=""
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (English)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />
                        <Controller
                            control={control}
                            name="localizations.tc.title"
                            defaultValue=""
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (Traditional Chinese)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />

                        <UploadImage
                            name="icon"
                            data={data}
                            control={control}
                            Controller={Controller}
                            setValue={setValue}
                            getValues={getValues}
                            disabled={disabled}
                            uploadLabel="Upload icon"
                            changeLabel="Change icon"
                            uploadFolder="FILMICON"
                        />

                        <Box
                            className={classes.subsectionHeader}>
                            <Grid item xs={12}>
                                <Box>
                                    <h4>
                                        <small>Title
                                            background
                                            color</small>
                                    </h4>
                                </Box>
                            </Grid>
                        </Box>
                        <Box>
                            <ColorPicker
                                getValues={getValues}
                                setValue={setValue}
                                defaultValue={data.color}
                                disabled={disabled}
                            />
                        </Box>

                        <Controller
                            control={control}
                            name="status"
                            render={({
                                         field: {
                                             value,
                                             onChange,
                                             ...rest
                                         },
                                         fieldState: {error},
                                     }) => (
                                <ToggleButtonGroup
                                    {...rest}
                                    value={value}
                                    onChange={(event, newFormats) => {
                                        if (newFormats !== null) {
                                            onChange(newFormats);
                                        }
                                    }}
                                    exclusive
                                    aria-label="Status"
                                    className={classes.input}
                                >
                                    <ToggleButton
                                        value={1}
                                        aria-label="Active"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton
                                        value={0}
                                        aria-label="Inactive"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Inactive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />

                        <Box display="flex"
                             alignItems="flex-end"
                             alignContent="flex-end">
                            {disabled || (
                                <Box>
                                    <Button
                                        className={classes.last}
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="submit"
                                    >
                                        {props.submitBtnTxt}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </>
    );
}
